<template>
    <a-modal :title="title"
             :width="800"
             :visible="visible"
             :maskClosable="false"
             @ok="onSave"
             @cancel="$emit('cancel')"
             destroyOnClose
             :confirmLoading="confirmLoading">
        <a-form :form="form">
            <a-form-item
                    label='模块描述名称'
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 12 }">
                <a-input v-decorator="['name', {initialValue:formData.name, rules: [{ required: true, message: '请填写模块描述名称' }]}]" placeholder='模块描述名称'/>
            </a-form-item>
            <a-form-item
                    label='附件标识Key'
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 12 }">
                <a-input v-decorator="['keyword', {initialValue:formData.keyword, rules: [{ required: true, message: '请填写附件标识Key' }]}]" placeholder='附件标识Key'/>
            </a-form-item>
            <a-form-item
                    label='存放路径'
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 12 }">
                <a-input v-decorator="['storePath', {initialValue:formData.storePath, rules: [{ required: true, message: '请填写存放路径' }]}]" placeholder='存放路径'/>
            </a-form-item>
            <a-form-item
                    label='允许格式'
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 12 }">
                <a-checkbox-group v-decorator="['extension', {initialValue:formData.extension, rules: [{ required: true, message: '请填写允许格式' }]}]" :options="extensions"/>
            </a-form-item>
            <a-form-item
                    label='最大值 (KB)'
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 12 }">
                <a-input v-decorator="['maxSize', {initialValue:formData.maxSize, rules: [{ required: true, message: '请填写最大值 (数字类型)'}]}]" placeholder='最大值 (KB)'/>
            </a-form-item>
            <a-form-item
                    label='存储方式'
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 12 }">
                <a-select v-decorator="['isExternal', {initialValue:formData.isExternal}]">
                    <a-select-option :value="0">本地存储</a-select-option>
                    <a-select-option :value="1">云存储</a-select-option>
                </a-select>
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
import qs from 'qs'

export default {
  name: 'AttachmentEdit',
  props: ['visible'],
  data () {
    return {
      form: this.$form.createForm(this),
      extensions: [
        // { label: 'GIF', value: 'gif' }
      ],
      mode: '',
      title: '',
      formData: {
        id: null,
        name: null,
        keyword: null,
        storePath: null,
        extension: null,
        maxSize: null,
        isExternal: 0
      },
      confirmLoading: false
    }
  },
  methods: {
    preAdd () {
      this.title = '新建上传配置'
      this.mode = 'add'
      this.resetModel()

      const that = this
      that.$http.get('/api/1/attachment/available_extensions.json').then(function (response) {
        let result = response.result
        that.extensions = that.mapCheckboxData(result)
      })
    },
    preEdit (id) {
      this.title = '编辑上传配置'
      this.mode = 'edit'
      this.resetModel()

      this.formData.id = id
      const that = this
      that.$http.get('/api/1/attachment/config.json?id=' + id).then(function (response) {
        let result = response.result

        that.extensions = that.mapCheckboxData(result.extras.extensions)

        result.maxSize = result.maxSize / 1024
        that.formData = result
      })
    },
    mapCheckboxData (list) {
      return list.map(item => {
        return {
          value: item.ext,
          label: item.name
        }
      })
    },
    resetModel () {
      this.formData = {
        id: null,
        name: null,
        keyword: null,
        storePath: null,
        extension: null,
        maxSize: null,
        isExternal: 0
      }
    },
    onSave () {
      const that = this
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        this.confirmLoading = true
        if (this.mode === 'add') {
          that.$http.post('/api/1/attachment/config-add.json', qs.stringify(this.form.getFieldsValue())).then(function () {
            that.confirmLoading = false
            that.$emit('success', that.mode)
          })
        } else {
          let params = this.form.getFieldsValue()
          params.id = that.formData.id
          that.$http.post('/api/1/attachment/config-edit.json', qs.stringify(params)).then(function () {
            that.confirmLoading = false
            that.$emit('success', that.mode)
          })
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
